// extracted by mini-css-extract-plugin
export default {"sendButtonContainer":"SendButton_sendButtonContainer__PHw5p"};